import { useState } from "react";
import {
    Container,
    Box,
    Button,
    CircularProgress,
    Typography,
    Modal,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem
} from "@mui/material";
import { DiseñoDataGrid } from "../../FuncionesGenerales/DataGrid";
import { FaTrashCan } from "react-icons/fa6";
import { DataGrid } from "@mui/x-data-grid";
import { BiFolderOpen } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { FaRegCircleCheck } from "react-icons/fa6";
import { BiErrorCircle } from "react-icons/bi";
import { useGetCategoriasRME, useExpenseCategoryRME } from "../../../Services/EgresosRME";
import { modalStyle, Texto, buttonGuardar, buttonCancelar, SubTitulo, buttonAtras, Input } from "../../../Layouts/CustomStyles";

export const CategoriaExpenseIndex = () => {

    // HOOKS
    const { categorias, loadingCategorias, refetchcategoria } = useGetCategoriasRME();
    const { crearCategoria, editarCategoria, eliminarCategoria } = useExpenseCategoryRME();

    // MODAL CREAR
    const [openCrear, setOpenCrear] = useState(false);
     const [selectedIngreso, setSelectedIngreso] = useState(null);
     const [openEdit, setOpenEdit] = useState(false);
         const [openDelete, setOpenDelete] = useState(false);
    const [nuevaCategoria, setNuevaCategoria] = useState({
    name: "",
    description: "",
    eerr: "",
    is_fixed: false,
});


    // ALERTAS
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [enviandoAlert, setEnviandoAlert] = useState(false);

    // COLUMNS DATAGRID
    const columns = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "name", headerName: "Nombre", flex: 1 },
        { field: "description", headerName: "Descripción", flex: 1 },
        { field: "eerr", headerName: "EERR categoria", flex: 1 },
        {
                    field: "acciones",
                    headerName: "Acción",
                    width: 150,
                    renderCell: (params) => {
                        return (
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 1,
                                    width: 150,
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <button className="edit-button" onClick={() => handleOpenEdit(params.row)}>
                                    <svg className="edit-svgIcon" viewBox="0 0 512 512">
                                        <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                                    </svg>
                                </button>
                                <button className="delete-button" onClick={() => handleOpenDelete(params.row)}>
                                    <FaTrashCan className="delete-svgIcon" />
                                </button>
                            </Box>
                        );
                    },
                },
    ];

    // ENVIAR NUEVA CATEGORÍA
    const handleCrearCategoria = async () => {
    setEnviandoAlert(true);


    try {
        await crearCategoria(nuevaCategoria);
        setOpenCrear(false);
        setNuevaCategoria({
            name: "",
            description: "",
            eerr: "",
            is_fixed: false
        });
        setAlertMessage("Categoría creada correctamente");
        setSuccessAlertOpen(true);
        refetchcategoria();
    } catch (err) {
        setAlertMessage("Error al crear categoría");
        setErrorAlertOpen(true);
    } finally {
        setEnviandoAlert(false);
    }
};


       const handleOpenEdit = (row) => {
        setSelectedIngreso(row);
        setOpenEdit(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(false);
        setSelectedIngreso(null);
    };

    const handleEditarIngreso = async () => {
        if (!selectedIngreso) return;

      
        try {
            setEnviandoAlert(true);

           const payload = {
    name: selectedIngreso.name,
    description: selectedIngreso.description,
    eerr: selectedIngreso.eerr,
    is_fixed: selectedIngreso.is_fixed ?? false
};



            await  editarCategoria(selectedIngreso.id, payload);

            setAlertMessage("egreso actualizado correctamente ✅");
            setSuccessAlertOpen(true);
            refetchcategoria(); // recarga la lista
            handleCloseEdit(); // cierra el modal
        } catch (error) {
            setAlertMessage(`Error al actualizar: ${error}`);
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };

    const handleOpenDelete = (row) => {
        setSelectedIngreso(row);
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
        setSelectedIngreso(null);
    };

     const handleEliminarIngreso = async () => {
        if (!selectedIngreso) return;

        try {
            setEnviandoAlert(true);

            await eliminarCategoria(selectedIngreso.id); // llama al API DELETE

            setAlertMessage("egreso eliminado correctamente ✅");
            setSuccessAlertOpen(true);
            refetchcategoria(); // recarga la lista
            handleCloseDelete();
        } catch (error) {
            setAlertMessage(`Error al eliminar: ${error}`);
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };
    return (
        <Container maxWidth="lg">

            {/* HEADER */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3, mt:4 }}>
                <Typography variant="h5" sx={Texto}>Categorías de Egresos</Typography>

                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#2a8d74",
                        borderRadius: "50px",
                        textTransform: "none",
                        fontFamily: "Poppins",
                    }}
                    onClick={() => setOpenCrear(true)}
                >
                    Agregar Categoría
                </Button>
            </Box>

            {/* LOADING */}
            {loadingCategorias && (
                <Box sx={{ textAlign: "center", py: 5 }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>Cargando categorías...</Typography>
                </Box>
            )}

            {/* ERROR / SIN DATOS */}
            {!loadingCategorias && categorias?.length === 0 && (
                <Box sx={{ textAlign: "center", py: 6 }}>
                    <BiFolderOpen style={{ fontSize: "4rem", color: "#999" }} />
                    <Typography variant="h6" sx={{ mt: 1 }}>
                        No hay categorías registradas
                    </Typography>
                    <Typography sx={{ color: "#666" }}>Crea una nueva categoría para comenzar</Typography>
                </Box>
            )}

            {/* DATAGRID */}
            {!loadingCategorias && categorias?.length > 0 && (
                <Box sx={{ height: 500, width: "100%" }}>
                    <DataGrid
                        rows={categorias}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        slots={{ noRowsOverlay: DiseñoDataGrid }}
                        sx={{
              fontFamily: 'Poppins, sans-serif',
              '& .MuiDataGrid-columnHeaders': {
                color: '#113e21ff',
                fontWeight: 600,
                textTransform: 'capitalize',
              },
              '& .MuiDataGrid-cell': {
                textTransform: 'capitalize',
              },
            }}
                    />
                </Box>
            )}

            {/* MODAL CREAR */}
            <Dialog open={openCrear} onClose={() => setOpenCrear(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={Texto}>Nueva Categoría</DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <TextField
                            label="Nombre"
                            value={nuevaCategoria.name}
                            onChange={(e) => setNuevaCategoria({ ...nuevaCategoria, name: e.target.value })}
                            fullWidth
                        />

                        <TextField
                            label="Descripción"
                            multiline
                            minRows={2}
                            value={nuevaCategoria.description}
                            onChange={(e) => setNuevaCategoria({ ...nuevaCategoria, description: e.target.value })}
                            fullWidth
                        />

                        <TextField
                          label="Categoría EERR"
                          select
                            value={nuevaCategoria.eerr}
                         onChange={(e) => setNuevaCategoria({ ...nuevaCategoria, eerr: e.target.value })}
                          fullWidth
                          sx={{...Input, mt:2}}
                        >
                             <MenuItem value="COSTO_OPERACIONAL">Costo Operacional</MenuItem>
                          <MenuItem value="OPERACIONAL"> Gasto Operacional</MenuItem>
                          <MenuItem value="NO_OPERACIONAL">Gasto No operacional</MenuItem>
                          <MenuItem value="ADMINISTRATIVO">Gasto Administrativo</MenuItem>
                           <MenuItem value="GASTO_FINANCIERO">Gasto Financiero</MenuItem>
                           <MenuItem value="INVERSIONES">Inversiones</MenuItem>
                          <MenuItem value="GENERAL">General</MenuItem>
                        </TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={buttonCancelar} onClick={() => setOpenCrear(false)}>Cancelar</Button>
                    <Button sx={buttonGuardar} onClick={handleCrearCategoria}>Guardar</Button>
                </DialogActions>
            </Dialog>

            {/* ALERT SUCCESS */}
            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* ALERT ERROR */}
            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* ALERT ENVIANDO */}
            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
                    <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
                            <DialogTitle sx={Texto}>Editar Egreso</DialogTitle>
                            <DialogContent>
                                {/* Aquí puedes poner un formulario con los campos de `selectedIngreso` */}
                               <Box display="flex" flexDirection="column" gap={2}>
                       <TextField
    sx={Input}
    label="Nombre"
    value={selectedIngreso?.name || ""}
    onChange={(e) =>
        setSelectedIngreso({ ...selectedIngreso, name: e.target.value })
    }
    fullWidth
/>

<TextField
    sx={Input}
    label="Descripción"
    multiline
    minRows={2}
    value={selectedIngreso?.description || ""}
    onChange={(e) =>
        setSelectedIngreso({ ...selectedIngreso, description: e.target.value })
    }
    fullWidth
/>

 <TextField
                          label="Categoría EERR"
                          select
                          value={selectedIngreso?.eerr}
                         onChange={(e) => setSelectedIngreso({ ...selectedIngreso, eerr: e.target.value })}
                          fullWidth
                          sx={{...Input, mt:2}}
                        >
                          <MenuItem value="COSTO_OPERACIONAL">Costo Operacional</MenuItem>
                          <MenuItem value="OPERACIONAL"> Gasto Operacional</MenuItem>
                          <MenuItem value="NO_OPERACIONAL">Gasto No operacional</MenuItem>
                          <MenuItem value="ADMINISTRATIVO">Gasto Administrativo</MenuItem>
                           <MenuItem value="GASTO_FINANCIERO">Gasto Financiero</MenuItem>
                           <MenuItem value="INVERSIONES">Inversiones</MenuItem>
                          <MenuItem value="GENERAL">General</MenuItem>
                        </TextField>
                    </Box>
                                {/* Agrega más campos según necesites */}
                            </DialogContent>
                            <DialogActions>
                                <Button sx={buttonCancelar} onClick={handleCloseEdit}>Cancelar</Button>
                                <Button sx={buttonGuardar} onClick={handleEditarIngreso}>
                                    {enviandoAlert ? "Guardando..." : "Guardar"}
                                </Button>
            
                            </DialogActions>
                        </Dialog>
            
            
                        <Dialog open={openDelete} onClose={handleCloseDelete}>
                            <DialogTitle sx={Texto}>Eliminar Egreso</DialogTitle>
                            <DialogContent sx={SubTitulo}>
                                ¿Estás seguro que quieres eliminar a {selectedIngreso?.name}?
                            </DialogContent>
                            <DialogActions>
                                <Button sx={buttonAtras} onClick={handleCloseDelete}>Cancelar</Button>
                                <Button
                                    onClick={handleEliminarIngreso} // 👈 usamos la función con alert y refetch
                                    sx={buttonCancelar}
                                >
                                    Eliminar
                                </Button>
                            </DialogActions>
                        </Dialog>
        </Container>
    );
};
